import Vue from 'vue';
export default {
  getServiceProductList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/product', { params });
  },
  getServiceCropList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/dict/product/crop/list', { params });
  },
  getServiceScoreLevelList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/dict/product/score-level/list', { params });
  },
  getServiceAreaLevelList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/dict/product/area-level/list', { params });
  },
  getAreaList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/dict/area/list', { params });
  },
  getServiceCategoryList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/dict/product/category/list', { params });
  },
  getServiceDetail (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/product/detail', { params });
  },
  getLandList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/user/lands/by/id-card', { params });
  },
  applyService (body) {
    return Vue.axios.post('/rx/user/api/v1.0/service/application', body);
  },
  getServiceList (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/product/list', { params });
  },
  // 判断该区域是否可以下托管订单
  checkTrustAreaCode (params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/application/area-code/check', { params });
  }
};
